import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcVisibility = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 19.75c1.183 0 2.188-.413 3.012-1.238.825-.825 1.238-1.829 1.238-3.012s-.413-2.188-1.238-3.012c-.825-.825-1.829-1.238-3.012-1.238s-2.188.412-3.012 1.238c-.825.825-1.238 1.829-1.238 3.012s.412 2.188 1.238 3.012c.825.825 1.829 1.238 3.012 1.238Zm0-1.45c-.783 0-1.446-.27-1.988-.813-.541-.541-.812-1.204-.812-1.987 0-.783.27-1.446.813-1.988.541-.541 1.204-.812 1.987-.812.783 0 1.446.27 1.988.813.541.541.812 1.204.812 1.987 0 .783-.27 1.446-.813 1.988-.541.541-1.204.812-1.987.812Zm0 4.7c-2.433 0-4.633-.692-6.6-2.075C7.433 19.542 5.967 17.733 5 15.5c.967-2.233 2.433-4.042 4.4-5.425C11.367 8.692 13.567 8 16 8s4.633.692 6.6 2.075c1.967 1.383 3.433 3.192 4.4 5.425-.967 2.233-2.433 4.042-4.4 5.425C20.633 22.308 18.433 23 16 23Zm0-1.5c2.017 0 3.87-.546 5.563-1.637a10.626 10.626 0 0 0 3.862-4.363 10.626 10.626 0 0 0-3.863-4.363A10.053 10.053 0 0 0 16 9.5c-2.017 0-3.87.546-5.563 1.637A10.804 10.804 0 0 0 6.55 15.5c.9 1.817 2.196 3.27 3.888 4.363A10.053 10.053 0 0 0 16 21.5Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
export default SvgIcVisibility;
